// extracted by mini-css-extract-plugin
export default {"header":"footer_header__wSpc3","pageFooter":"footer_pageFooter__+ucYn","sectionFooter":"footer_sectionFooter__uXcI1","dialogFooter":"footer_dialogFooter__U4JRd"};